<template>
  <div id="versionChange">
    <table class="changetable"
           width="960">
      <tbody>
        <tr style="height:60px;font-size:18px;">
          <th colspan="4">
            <b>CDP-LOCAL-WEB-API</b>
          </th>
        </tr>

        <tr>
          <td width='15%'>当前时间：</td>
          <td width='35%'>{{now}}</td>
          <td width='15%'>更新时间：</td>
          <td width='35%'>2022/05/20 10:00</td>
        </tr>

        <tr style="height:50px;">
          <th colspan="4">
            <b>版本更新日志（仅记录重大更新）</b>
          </th>
        </tr>

        <tr>
          <td>
            <b>v2.1.9</b>
            <br>
            <b>2022/05/20 10:00</b>
            <br>
            <b>接口版本号：v2.9.2</b>
            <b v-if="apiFlag">接口更新时间：2022/05/20 10:00</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 文稿路径改成组件的预览</li>
            </ol>
          </td>
        </tr> 
        <tr>
          <td>
            <b>v2.1.8</b>
            <br>
            <b>2022/01/24 11:00</b>
            <br>
            <b>接口版本号：v2.9.1</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复新增手动标签的问题</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.7</b>
            <br>
            <b>2022/01/20 10:00</b>
            <br>
            <b>接口版本号：v2.9.1</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 视频新增手动标签</li>
              <li>2. 图片列表新增大小和上传时间筛选</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.6</b>
            <br>
            <b>2022/01/04 18:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善二级图库上传问题</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.5</b>
            <br>
            <b>2021/12/29 10:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善二级图库</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.4</b>
            <br>
            <b>2021/12/27 17:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图库可以新增二级</li>
              <li>2. 完善标签管理和分类管理</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.3</b>
            <br>
            <b>2021/12/21 15:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善手动标签功能</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.2</b>
            <br>
            <b>2021/12/17 15:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/12/16 17:25:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 注册用户新增：公司，职位和部门三个</li>
              <li>2. 基础配置新增背景图上传</li>
              <li>3. 图片列表中新增表格切换</li>
              <li>4. 新增数据分析模块</li>
              <li>5. 新增标签管理模块</li>
              <li>6. 新增分类管理模块</li>
              <li>7. 个人图集和媒资检索的图片可以手动新增标签</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.1</b>
            <br>
            <b>2021/11/24 15:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/24 18:01:04</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复拍摄时间筛选问题</li>
              <li>2. 放开图片说明</li>
              <li>3. 修复个人图集滚动问题</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.1.0</b>
            <br>
            <b>2021/09/26 10:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/24 18:01:04</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增普通单点登录配置</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.9</b>
            <br>
            <b>2021/09/18 09:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/07 09:45:59</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修改活动征稿无法查看图片问题</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.8</b>
            <br>
            <b>2021/09/15 12:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/07 09:45:59</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增鉴权配置</li>
              <li>2. 移动回收站的位置</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.7</b>
            <br>
            <b>2021/09/13 18:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/07 09:45:59</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复分辨率导致的框错位问题</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.6</b>
            <br>
            <b>2021/09/10 18:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/07 09:45:59</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复回收站的顺序问题</li>
              <li>2. 新增分词检索</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.5</b>
            <br>
            <b>2021/09/09 09:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/07 09:45:59</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图集的图片无法查看</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.4</b>
            <br>
            <b>2021/09/07 18:00</b>
            <br>
            <b>接口版本号：v2.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/09/07 09:45:59</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增下载日志记录</li>
              <li>2. 新增资源集中图片批量删除操作</li>
              <li>3. 新增栏目征稿批量发布操作</li>
            </ol>
          </td>
        </tr> 

        <tr>
          <td>
            <b>v2.0.3</b>
            <br>
            <b>2021/09/06 12:00</b>
            <br>
            <b>接口版本号：v2.8.9</b>
            <b v-if="apiFlag">接口更新时间：2021/09/03 17:30:11</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增文稿回收站</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v2.0.2</b>
            <br>
            <b>2021/09/03 18:00</b>
            <br>
            <b>接口版本号：v2.8.9</b>
            <b v-if="apiFlag">接口更新时间：2021/09/03 15:00:53</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增视频回收站</li>
              <li>2. 所有展示视频的地方新增删除操作</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v2.0.1</b>
            <br>
            <b>2021/09/02 18:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/26 16:32:28</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增图片回收站</li>
              <li>2. 修复图片放大之后人脸错位问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v2.0.0</b>
            <br>
            <b>2021/09/01 18:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/26 16:32:28</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修改我的文稿展示样式</li>
              <li>2. 修复图片移除问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.9</b>
            <br>
            <b>2021/08/31 18:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/26 16:32:28</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增我的文稿页面</li>
              <li>2. 优化视频加载</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.8</b>
            <br>
            <b>2021/08/30 18:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/26 16:32:28</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修缮空资源上传问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.7</b>
            <br>
            <b>2021/08/27 17:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/26 16:32:28</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 媒资检索的文稿新增图片和字数筛选</li>
              <li>2. 媒资检索的文稿新增预览操作</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.6</b>
            <br>
            <b>2021/08/26 18:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/26 16:32:28</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 个人资源夹中新增文稿操作</li>
              <li>2. 修改栏目征稿打包下载</li>
              <li>3. 修复上传限制问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.5</b>
            <br>
            <b>2021/08/25 18:00</b>
            <br>
            <b>接口版本号：v2.8.6</b>
            <b v-if="apiFlag">接口更新时间：2021/08/25 16:15:24</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 个人资源库的资源夹的图片可以批量修改说明</li>
              <li>2. 支持文稿上传</li>
              <li>3. 修改侧边栏的样式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.4</b>
            <br>
            <b>2021/08/18 18:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复云效的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.3</b>
            <br>
            <b>2021/08/17 15:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复短图显示问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.2</b>
            <br>
            <b>2021/08/16 11:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修缮列表显示</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.1</b>
            <br>
            <b>2021/08/13 15:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修缮图片展示</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.9.0</b>
            <br>
            <b>2021/08/12 12:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增水印设置</li>
              <li>2. 完善图集样式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.9</b>
            <br>
            <b>2021/08/10 18:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增微信配置</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.8</b>
            <br>
            <b>2021/08/06 11:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复栏目征稿和活动征稿翻页问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.7</b>
            <br>
            <b>2021/08/06 12:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 后台移动端新增状态筛选</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.6</b>
            <br>
            <b>2021/08/04 17:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 后台发布可以查看图片</li>
              <li>2. 修复媒资检索中的问题</li>
              <li>3. 修改图片列表瀑布流的高度</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.5</b>
            <br>
            <b>2021/08/03 15:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 栏目征稿更改下载规则</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.4</b>
            <br>
            <b>2021/08/02 16:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/30 15:27:05</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增简易版我的图片页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.3</b>
            <br>
            <b>2021/07/30 16:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/29 09:42:53</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增我的视频页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.2</b>
            <br>
            <b>2021/07/29 11:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/29 09:42:53</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片显示不全</li>
              <li>2. 新增强弱密码的判断</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.1</b>
            <br>
            <b>2021/07/28 18:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/26 09:34:44</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 移动端上传新增推送至图片直播</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.8.0</b>
            <br>
            <b>2021/07/26 11:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/26 09:34:44</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复后台无法筛选人物</li>
              <li>2. 修复查看图片的定位和显示问题</li>
              <li>3. 修复直播标题过长问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.9</b>
            <br>
            <b>2021/07/23 12:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/23 11:00:47</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增微信扫码登录</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.8</b>
            <br>
            <b>2021/07/21 17:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/21 11:21:44</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 后台手机端新增推送到直播和下载图片</li>
              <li>2. 完善直播的图片集</li>
              <li>3. 上传新增推送操作</li>
              <li>4. 基础设置的认证相关添加摄影师协会和摄影师协会职务</li>
              <li>5. 文本与协议管理添加摄影师协会和摄影师协会职务对应配置</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.7</b>
            <br>
            <b>2021/07/20 14:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/20 11:16:01</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复一系列问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.6</b>
            <br>
            <b>2021/07/19 16:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/16 16:26:09</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.媒资检索新增图片下载日志</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.5</b>
            <br>
            <b>2021/07/16 12:00</b>
            <br>
            <b>接口版本号：v2.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/07/16 09:34:01</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.新增图片直播</li>
              <li>2.图片下载日志</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.4</b>
            <br>
            <b>2021/07/07 11:00</b>
            <br>
            <b>接口版本号：v2.7.4</b>
            <b v-if="apiFlag">接口更新时间：2021/07/06 18:58:32</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.图片打包下载可以选择清晰度</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.3</b>
            <br>
            <b>2021/07/05 16:00</b>
            <br>
            <b>接口版本号：v2.7.4</b>
            <b v-if="apiFlag">接口更新时间：2021/07/05 10:44:30</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.修复审核活动征稿的图片，按照活动名称筛选，一直在转圈加载不出</li>
              <li>2.修复投稿审核限制拒绝理由字数</li>
              <li>3.缩率图生成失败的图片可以查看原图</li>
              <li>4.运维操作中增加重新生成图片缩略图</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.2</b>
            <br>
            <b>2021/07/02 10:00</b>
            <br>
            <b>接口版本号：v2.7.3</b>
            <b v-if="apiFlag">接口更新时间：2021/07/01 17:28:58</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.修复推送之后栏目不清空</li>
            </ol>
          </td>
        </tr>

        

        <tr>
          <td>
            <b>v1.7.1</b>
            <br>
            <b>2021/07/01 16:00</b>
            <br>
            <b>接口版本号：v2.7.2</b>
            <b v-if="apiFlag">接口更新时间：2021/06/30 16:13:41</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.完善视频下载功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.7.0</b>
            <br>
            <b>2021/06/30 17:55</b>
            <br>
            <b>接口版本号：v2.7.1</b>
            <b v-if="apiFlag">接口更新时间：2021/06/29 12:05:13</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.新增视频下载功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.6.9</b>
            <br>
            <b>2021/06/29 16:55</b>
            <br>
            <b>接口版本号：v2.7.1</b>
            <b v-if="apiFlag">接口更新时间：2021/06/29 12:05:13</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.修复活动征稿是视频征稿，应该显示已征集多少个视频</li>
              <li>2.图片展示列表新增选用功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.6.8</b>
            <br>
            <b>2021/06/29 10:10</b>
            <br>
            <b>接口版本号：v2.6.8</b>
            <b v-if="apiFlag">接口更新时间：2021/06/28 16:46:03</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1.修复活动征稿是视频征稿，应该显示已征集多少个视频</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.6.7</b>
            <br>
            <b>2021/06/28 18:00</b>
            <br>
            <b>接口版本号：v2.6.8</b>
            <b v-if="apiFlag">接口更新时间：2021/06/28 16:46:03</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增个人图集批量移动</li>
              <li>2. 媒资检索新增视频列表</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.6.6</b>
            <br>
            <b>2021/06/25 15:00</b>
            <br>
            <b>接口版本号：v2.3.4</b>
            <b v-if="apiFlag">接口更新时间：2021/06/25 10:42:17</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 同时有视频和图片的图集只能分享图片</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.6.5</b>
            <br>
            <b>2021/06/24 15:00</b>
            <br>
            <b>接口版本号：v2.3.0</b>
            <b v-if="apiFlag">接口更新时间：2021/06/23 16:15:39</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复工作流已知bug</li>
              <li>2. 修复个人资源库图片移动bug</li>
              <li>3. 完善视频上传和播放功能</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.6.4</b>
            <br>
            <b>2021/06/23 18:00</b>
            <br>
            <b>接口版本号：v2.3.0</b>
            <b v-if="apiFlag">接口更新时间：2021/06/23 15:23:40</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 可以上传视频资源</li>
              <li>2. 个人图集可以查看视频资源</li>
              <li>3. 更改了图集展示的三个按钮</li>
              <li>4. 工作流增加一键发布</li>
              <li>5. 工作流显示已发布栏目</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.6.3</b>
            <br>
            <b>2021/06/21 17:00</b>
            <br>
            <b>接口版本号：v2.5.4</b>
            <b v-if="apiFlag">接口更新时间：2021/06/16 16:15:39</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 显示拒绝理由</li>
              <li>2. 站点推送携带栏目名</li>
              <li>3. 手机后台图集改为两排展示</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.6.1</b>
            <br>
            <b>2021/06/18 16:00</b>
            <br>
            <b>接口版本号：v2.5.4</b>
            <b v-if="apiFlag">接口更新时间：2021/06/16 16:15:39</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 稿件推送到站点发布和全媒体带入标题和内容</li>
              <li>2. 修复个人图集入库时间筛选无效</li>
              <li>3. 修复推送到图片邀约无法选择</li>
              <li>4. 修复上传缺少图集</li>
              <li>5. 修复个人图集搜索状态保存</li>
              <li>6. 修复站点发布分页错位</li>
              <li>7. 弱密码强制修改</li>
              <li>8. 完成手机后台推送功能</li>
              <li>9. 手机后台图片展示参照手机</li>
              <li>10. 修复手机后台上传logo错误</li>
              <li>11. 查看图片展示所属资源库信息</li>
              <li>12. 修复保留选用操作按钮失效</li>
              <li>13. 我的下载展示近三月内，可以删除</li>
              <li>14. 用户管理可以搜索手机号</li>
              <li>15. 图片中心查看图片时右侧所属图集可以点击查看</li>
              <li>16. 修复图片邀约打包下载</li>
              <li>17. 工作流征稿提供角色筛选</li>
              <li>18. 修复工作流征稿中选用图片后创建图集失败问题</li>
              <li>19. 修复手机后台已知bug</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.6.0</b>
            <br>
            <b>2021/06/10 17:00</b>
            <br>
            <b>接口版本号：v2.5.1</b>
            <b v-if="apiFlag">接口更新时间：2021/06/09 16:15:39</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复全选按钮失效</li>
              <li>2. 修复选用保留按钮失效</li>
              <li>3. 修复手机后台图片错位</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.5.9</b>
            <br>
            <b>2021/06/08 17:30</b>
            <br>
            <b>接口版本号：v2.4.9</b>
            <b v-if="apiFlag">接口更新时间：2021/06/03 14:39:20</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复选用后站点推送问题</li>
              <li>2. 增加站点发布列表的修改日期</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.5.8</b>
            <br>
            <b>2021/06/02 16:30</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.5.7</b>
            <br>
            <b>2021/06/01 09:55</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复缩略图生成失败无法选用</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.5.6</b>
            <br>
            <b>2021/05/26 14:30</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复审核栏目投稿功能中的bug</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.5.5</b>
            <br>
            <b>2021/05/25 16:30</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加后台审核栏目投稿功能</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.5.4</b>
            <br>
            <b>2021/05/13 17:50</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复打包下载失败问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.5.3</b>
            <br>
            <b>2021/05/12 13:50</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复刷新logo消失问题</li>
              <li>2. 个人资源库与图片中心图库一致</li>
              <li>3. 不允许修改活动投稿时图片和视频切换</li>
              <li>4. 修复打包下载失败</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.5.2</b>
            <br>
            <b>2021/05/10 14:04</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 修复在权限管理中，没有打开人脸识别管理的权限，也可以在图片中心标注人物。</li>
              <li>2. 修复无法完成单点登录</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.5.3</b>
            <br>
            <b>2021/05/12 11:04</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复刷新logo消失问题 </li>
              <li>2. 个人资源库与图片中心图库一致</li>
              <li>3. 不允许修改活动投稿时图片和视频切换</li>
              <li>4. 修复打包下载失败</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.5.2</b>
            <br>
            <b>2021/05/10 14:04</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/05/07 17:26:52</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 修复在权限管理中，没有打开人脸识别管理的权限，也可以在图片中心标注人物。</li>
              <li>2. 修复无法完成单点登录</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.5.1</b>
            <br>
            <b>2021/05/08 17:34</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/04/30 11:10:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复0340 已投稿件切换页面大小可以点击查看</li>
              <li>2. 修复个人资源库点击小红心切换</li>
              <li>3. 加快云知前台展示页面打开速度</li>
              <li>4. 角色数量可超过20</li>
              <li>5. 修复图片邀约报错</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.5.0</b>
            <br>
            <b>2021/05/07 17:34</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/04/30 11:10:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复0190 投稿拒绝理由必填</li>
              <li>2. 修复0312 上传图片都有图片说明</li>
              <li>3. 修复0341 已改成对应图标</li>
              <li>4. 修复0345 都有对应创建时间</li>
              <li>5. 修复人物姓名过长</li>
              <li>6. 搜索条件自动清空</li>
              <li v-if="!isSimple">7. 删除资源集中的人物筛选</li>
              <li>8. 基础设置的全媒体图片导入增加默认导入用户</li>
            </ol>
          </td>
        </tr>
        <tr>
          <td>
            <b>v1.4.9</b>
            <br>
            <b>2021/04/30 17:24</b>
            <br>
            <b>接口版本号：v2.3.6</b>
            <b v-if="apiFlag">接口更新时间：2021/04/30 11:10:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 基础配置增加全媒体图片导入配置</li>
              <li>2. 完善查看关联图片的界面</li>
              <li v-if="!isSimple">3. 完善人脸展示页面</li>
              <li>4. 替换云知登录页面图片</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.8</b>
            <br>
            <b>2021/04/29 17:30</b>
            <br>
            <b>接口版本号：v2.3.4</b>
            <b v-if="apiFlag">接口更新时间：2021/04/29 17:10:53</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 完善资源人物管理查询关联的图片</li>
              <li v-if="!isSimple">2. 个人图集和图片中心点击人物可以查看关联图片</li>
              <li>3. 修复运维中心点击没有反应问题</li>
              <li>4. 图片如果生成失败一样可以查看原图</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.7</b>
            <br>
            <b>2021/04/28 17:38</b>
            <br>
            <b>接口版本号：v2.3.4</b>
            <b v-if="apiFlag">接口更新时间：2021/04/28 16:55:22</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 完善人脸识别功能</li>
              <li>2. 移动端图片上传支持多选图片</li>
              <li>3. 修复图片邀约中没有图片问题</li>
              <li>4. 图片上传可以上传jpeg格式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.6</b>
            <br>
            <b>2021/04/26 17:22</b>
            <br>
            <b>接口版本号：v2.3.1</b>
            <b v-if="apiFlag">接口更新时间：2021/04/25 10:47:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增活动个人中心页面</li>
              <li>2. 完善活动投稿的移动端页面</li>
              <li>3. 修复个人图集中的图片选用之后无法显示红心</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.5</b>
            <br>
            <b>2021/04/25 18:02</b>
            <br>
            <b>接口版本号：v2.3.1</b>
            <b v-if="apiFlag">接口更新时间：2021/04/25 10:47:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0264 已修复</li>
              <li>2. 完善图片上传的图片说明</li>
              <li>3. 增加前台个人主页的部分页面</li>
              <li>4. 完成活动分享，多选等微信问题</li>
              <li>5. 完成活动投稿的移动端页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.4</b>
            <br>
            <b>2021/04/23 15:50</b>
            <br>
            <b>接口版本号：v2.3.1</b>
            <b v-if="apiFlag">接口更新时间：2021/04/20 22:16:22</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 修改人物管理逻辑</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.3</b>
            <br>
            <b>2021/04/20 17:58</b>
            <br>
            <b>接口版本号：v2.3.1</b>
            <b v-if="apiFlag">接口更新时间：2021/04/20 17:21:24</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增图片邀约打包触发按钮</li>
              <li>2. 基础设置中增加微信相关配置</li>
              <li v-if="!isSimple">3. 云图中的运维操作中隐藏人脸和分类相关内容</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.2</b>
            <br>
            <b>2021/04/19 10:50</b>
            <br>
            <b>接口版本号：v2.2.11</b>
            <b v-if="apiFlag">接口更新时间：2021/04/16 18:06:03</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 优化路由懒加载</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.1</b>
            <br>
            <b>2021/04/16 17:50</b>
            <br>
            <b>接口版本号：v2.2.11</b>
            <b v-if="apiFlag">接口更新时间：2021/04/14 09:51:01</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复选用图片推送过去没有图片问题</li>
              <li>2. 图在logo更改为云图logo</li>
              <li>3. 0333 已修复</li>
              <li>4. 0334 已修复</li>
              <li>5. 0335 已修复</li>
              <li>6. 0336 已修复</li>
              <li>7. 0337 已修复</li>
              <li>8. 0338 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.4.0</b>
            <br>
            <b>2021/04/14 17:50</b>
            <br>
            <b>接口版本号：v2.2.11</b>
            <b v-if="apiFlag">接口更新时间：2021/04/14 09:51:01</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0327 已修复</li>
              <li>2. 0328 已修复</li>
              <li>3. 0329 已修复</li>
              <li>4. 0330 已修复</li>
              <li>5. 精简前后端打包文件，让项目更快的打开</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.9</b>
            <br>
            <b>2021/04/13 16:08</b>
            <br>
            <b>接口版本号：v2.2.11</b>
            <b v-if="apiFlag">接口更新时间：2021/04/13 09:46:56</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 4-13 已完成</li>
              <li>2. 修复并完善新版图片中心</li>
              <li>3. 减少前台打包代码</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.8</b>
            <br>
            <b>2021/04/12 11:11</b>
            <br>
            <b>接口版本号：v2.2.11</b>
            <b v-if="apiFlag">接口更新时间：2021/04/10 21:45:43</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 优化图片中心</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.7</b>
            <br>
            <b>2021/04/09 17:47</b>
            <br>
            <b>接口版本号：v2.2.10</b>
            <b v-if="apiFlag">接口更新时间：2021/04/09 15:37:406</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片中心的图片检索增加一种检索方式；接口为新增的advSearchPicture</li>
              <li>2. 优化系统更新页面并且自动跳转登录页面</li>
              <li>3. 修复站点管理的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.6</b>
            <br>
            <b>2021/04/08 17:56</b>
            <br>
            <b>接口版本号：v2.2.9</b>
            <b v-if="apiFlag">接口更新时间：2021/04/08 00:21:15</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善第一次加载版本切换有缝隙</li>
              <li>2. 新增系统更新页面用于解决当接口服务中断时，登录页默认强制呈现【图在】的样式的问题</li>
              <li>3. 新增advSearchPicture接口</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.5</b>
            <br>
            <b>2021/04/07 17:46</b>
            <br>
            <b>接口版本号：v2.2.7</b>
            <b v-if="apiFlag">接口更新时间：2021/04/06 23:32:34</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片生成逻辑</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.4</b>
            <br>
            <b>2021/04/06 17:08</b>
            <br>
            <b>接口版本号：v2.2.6</b>
            <b v-if="apiFlag">接口更新时间：2021/04/02 19:07:02</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 运维操作新增检索数据全量同步</li>
              <li>2. 完善移动端上传图片</li>
              <li>3. 优化图片中心</li>
              <li>4. 图片正在生成时使用原图展示</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.3</b>
            <br>
            <b>2021/04/02 17:48</b>
            <br>
            <b>接口版本号：v2.2.5</b>
            <b v-if="apiFlag">接口更新时间：2021/03/29 18:02:57</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增了手机投稿的橙色版本</li>
              <li>2. 完善了图片中心的逻辑和样式</li>
              <li>3. 优化了登录的闪退问题</li>
              <li>4. 优化了登录系统闪烁橙蓝问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.2</b>
            <br>
            <b>2021/04/01 17:39</b>
            <br>
            <b>接口版本号：v2.2.5</b>
            <b v-if="apiFlag">接口更新时间：2021/03/29 18:02:57</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善3-28</li>
              <li>2. 修复上传logo变形</li>
              <li>3. 修复进入系统会闪现橙色主题</li>
              <li>4. 修复移动端上传图片的样式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.1</b>
            <br>
            <b>2021/03/30 17:33</b>
            <br>
            <b>接口版本号：v2.2.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/29 18:02:57</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0294 已修复</li>
              <li>2. 0295 已修复</li>
              <li>3. 0296 已修复</li>
              <li>4. 0297 已修复</li>
              <li>5. 0300 已修复</li>
              <li>6. 修复新版图片中心的一系列的问题</li>
              <li>7. 修复移动端图片检索界面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.3.0</b>
            <br>
            <b>2021/03/29 17:15</b>
            <br>
            <b>接口版本号：v2.2.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/26 01:13:24</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 3-31 已完成</li>
              <li>2. 0296 已修复</li>
              <li>3. 完善图片中心的内容</li>
              <li>4. 限制每次投稿图片数为1到20张</li>
              <li>5. 修复资源集名过长溢出框框的问题</li>
              <li>6. 修复图片上传时填写了图片说明却是资源集名加图集说明的问题</li>
              <li>7. 改变所有多选框的颜色</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.9</b>
            <br>
            <b>2021/03/26 17:25</b>
            <br>
            <b>接口版本号：v2.2.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/26 01:13:24</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0264 已修复</li>
              <li>2. 0265 已修复</li>
              <li>3. 0278 已修复</li>
              <li>4. 0279 已修复</li>
              <li>5. 0280 已修复</li>
              <li>6. 0281 已修复</li>
              <li>7. 0282 已修复</li>
              <li>8. 0288 已修复</li>
              <li>9. 0292 已修复</li>
              <li>10. 完善图片中心的内容</li>
              <li>11. 修复全媒体推送不显示标题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.8</b>
            <br>
            <b>2021/03/25 17:55</b>
            <br>
            <b>接口版本号：v2.2.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/23 12:00:29</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 3-24 已完成（改版图片中心）</li>
              <li>2. 3-37 已完成（新增关于）</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.7</b>
            <br>
            <b>2021/03/24 17:44</b>
            <br>
            <b>接口版本号：v2.2.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/23 12:00:29</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加新版图片中心静态页面和部分动态页面功能</li>
              <li>2. 修复登录到期后直接进入登录页面</li>
              <li>3. 完善移动端检索图片</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.6</b>
            <br>
            <b>2021/03/23 17:36</b>
            <br>
            <b>接口版本号：v2.2.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/23 12:00:29</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 3-32 已完成</li>
              <li>2. 3-33 已完成</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.5</b>
            <br>
            <b>2021/03/22 16:28</b>
            <br>
            <b>接口版本号：v2.2.2</b>
            <b v-if="apiFlag">接口更新时间：2021/03/21 23:08:45</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 3-34 已完成</li>
              <li>2. 3-35 已完成</li>
              <li>3. 0195 已修复</li>
              <li>4. 0196 已修复</li>
              <li>5. 0218 已修复</li>
              <li>6. 0258 已修复</li>
              <li>7. 调整表格的展示方式</li>
              <li>8. 调整我的资源集中的样式</li>
              <li>9. 修缮弹出层的次数(限制每次只能弹出一个)</li>
              <li>10. 完善移动端检索图集页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.4</b>
            <br>
            <b>2021/03/19 17:28</b>
            <br>
            <b>接口版本号：v2.1.10</b>
            <b v-if="apiFlag">接口更新时间：2021/03/18 09:56:47</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0183 已修复</li>
              <li>2. 删除第一次刷新的多余接口</li>
              <li>3. 修复图片中心图片占位问题</li>
              <li>4. 增加移动端图片搜索界面</li>
              <li>5. 完善移动端登录界面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.4</b>
            <br>
            <b>2021/03/18 17:48</b>
            <br>
            <b>接口版本号：v2.1.8</b>
            <b v-if="apiFlag">接口更新时间：2021/03/18 09:56:47</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片中心增加东方网的推送</li>
              <li>2. 图片上传增加东方网的推送</li>
              <li>3. 修复图片上传选择13张以上显示不全的问题</li>
              <li>4. 更改上传进度条的样式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.3</b>
            <br>
            <b>2021/03/17 17:41</b>
            <br>
            <b>接口版本号：v2.1.8</b>
            <b v-if="apiFlag">接口更新时间：2021/03/17 00:43:46</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 3-09 已完成</li>
              <li>2. 3-10 已完成</li>
              <li>3. 3-12 已完成</li>
              <li>4. 3-25 已完成</li>
              <li>5. 3-26 已完成</li>
              <li>6. 3-27 已完成</li>
              <li>7. 0222 已修复</li>
              <li>8. 0230 已修复</li>
              <li>9. 0236 已修复</li>
              <li>10. 0237 已修复</li>
              <li>11. 0238 已修复</li>
              <li>12. 0240 已修复</li>
              <li>13. 增加后台移动端图片检索页面</li>
              <li>14. 修复上传丢图问题</li>
              <li>15. 完善了基础版样式问题</li>
              <li>16. 修复活动页面一系列问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.2</b>
            <br>
            <b>2021/03/16 21:01</b>
            <br>
            <b>接口版本号：v2.1.7</b>
            <b v-if="apiFlag">接口更新时间：2021/03/10 23:40:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.1</b>
            <br>
            <b>2021/03/15 14:01</b>
            <br>
            <b>接口版本号：v2.1.7</b>
            <b v-if="apiFlag">接口更新时间：2021/03/10 23:40:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复选用图片问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.2.0</b>
            <br>
            <b>2021/03/12 11:01</b>
            <br>
            <b>接口版本号：v2.1.7</b>
            <b v-if="apiFlag">接口更新时间：2021/03/10 23:40:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复抽屉的没有选择图片就推送分享和打包的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.9</b>
            <br>
            <b>2021/03/11 17:51</b>
            <br>
            <b>接口版本号：v2.1.7</b>
            <b v-if="apiFlag">接口更新时间：2021/03/10 23:40:27</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修缮</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.8</b>
            <br>
            <b>2021/03/10 14:31</b>
            <br>
            <b>接口版本号：v2.1.5</b>
            <b v-if="apiFlag">接口更新时间：2021/03/10 11:31:53</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复推送渠道问题</li>
              <li>2. 新增第三方登录页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.7</b>
            <br>
            <b>2021/03/09 13:51</b>
            <br>
            <b>接口版本号：v2.1.4</b>
            <b v-if="apiFlag">接口更新时间：2021/03/09 11:26:01</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善基础班功能</li>
              <li>2. 增加批量删除个人图集</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.6</b>
            <br>
            <b>2021/03/08 14:51</b>
            <br>
            <b>接口版本号：v2.1.3</b>
            <b v-if="apiFlag">接口更新时间：2021/03/08 13:45:55</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增单点登录配置模块</li>
              <li>2. 0201 已修复</li>
              <li>3. 0204 已修复</li>
              <li>4. 0213 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.5</b>
            <br>
            <b>2021/03/05 16:51</b>
            <br>
            <b>接口版本号：v2.1.0</b>
            <b v-if="apiFlag">接口更新时间：2021/03/04 17:18:48</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善基础版模块</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.4</b>
            <br>
            <b>2021/03/04 17:51</b>
            <br>
            <b>接口版本号：v2.1.0</b>
            <b v-if="apiFlag">接口更新时间：2021/03/04 17:18:48</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增基础版登录模块</li>
              <li>2. 新增基础版移动端登录模块</li>
              <li>3. 新增基础版主题颜色</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.3</b>
            <br>
            <b>2021/03/02 13:00</b>
            <br>
            <b>接口版本号：v2.0.5</b>
            <b v-if="apiFlag">接口更新时间：2021/03/01 17:45:40</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修改图片浏览时选用图片报错问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.2</b>
            <br>
            <b>2021/03/01 16:45</b>
            <br>
            <b>接口版本号：v2.0.5</b>
            <b v-if="apiFlag">接口更新时间：2021/02/28 22:54:42</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修改回调模块内容</li>
              <li>2. 修复选用图片问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.2</b>
            <br>
            <b>2021/02/26 17:10</b>
            <br>
            <b>接口版本号：v2.0.2</b>
            <b v-if="apiFlag">接口更新时间：2021/02/25 17:37:19</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 上传图片新增推送到个人用户操作</li>
              <li>2. 活动征稿新增推送到个人用户操作</li>
              <li>3. 活动征稿新增分享到工作圈操作</li>
              <li>4. 图片中心新增推送到个人用户操作</li>
              <li>5. 0169 已修复</li>
              <li>6. 0170 已修复</li>
              <li>7. 0182 已修复</li>
              <li>8. 0185 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.1</b>
            <br>
            <b>2021/02/25 18:10</b>
            <br>
            <b>接口版本号：v2.0.1</b>
            <b v-if="apiFlag">接口更新时间：2021/02/25 01:32:49</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 更改分享呈现方式</li>
              <li>2. 0172 已修复</li>
              <li>3. 0176 已修复</li>
              <li>4. 0177 已修复</li>
              <li>5. 0180 已修复</li>
              <li>6. 我的推送和我的分享，点击标题可以查看备注</li>
              <li>7. 推送给我的推送渠道换成推送来源</li>
              <li>8. 活动征稿审核增加视频查看</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.1.0</b>
            <br>
            <b>2021/02/24 18:10</b>
            <br>
            <b>接口版本号：v1.9.10</b>
            <b v-if="apiFlag">接口更新时间：2021/02/24 18:07:54</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/24 00:10:16</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增分享功能---工作圈</li>
              <li>2. 新增我的分享和浏览工作圈页面</li>
              <li>3. 完善工作圈管理页面</li>
              <li>4. 新增视频投稿内容</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.9</b>
            <br>
            <b>2021/02/23 17:41</b>
            <br>
            <b>接口版本号：v1.9.5</b>
            <b v-if="apiFlag">接口更新时间：2021/02/22 23:29:33</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X157 已修复</li>
              <li>2. 增加工作圈管理页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.8</b>
            <br>
            <b>2021/02/22 17:56</b>
            <br>
            <b>接口版本号：v1.9.3</b>
            <b v-if="apiFlag">接口更新时间：2021/02/22 11:42:26</b>
            <!-- <b v-if="apiFlag">接口更新时间：2021/02/21 23:20:21</b> -->
          </td>
          <td colspan="3">
            <ol>
              <li>1. GC0006 已完成</li>
              <li>2. 创建活动可以选择投稿类型（图文和视频）</li>
              <li>3. 修复查看投稿人报错问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.7</b>
            <br>
            <b>2021/02/20 17:46</b>
            <br>
            <b>接口版本号：v1.9.0</b>
            <b v-if="apiFlag">接口更新时间：2021/02/20 00:03:55</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加推送到用户的静态页面</li>
              <li>2. 前台增加视频投稿的静态页面</li>
              <li>3. 更改图片中心里图片和图集的位置</li>
              <li>4. 更改workflow的api前缀</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.6</b>
            <br>
            <b>2021/02/09 11:46</b>
            <br>
            <b>接口版本号：v1.8.8</b>
            <b v-if="apiFlag">接口更新时间：2021/02/05 17:49:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复上传并推送的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.5</b>
            <br>
            <b>2021/02/08 15:00</b>
            <br>
            <b>接口版本号：v1.8.8</b>
            <b v-if="apiFlag">接口更新时间：2021/02/05 17:49:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加ssr配置项</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.4</b>
            <br>
            <b>2021/02/07 16:00</b>
            <br>
            <b>接口版本号：v1.8.7</b>
            <b v-if="apiFlag">接口更新时间：2021/02/05 17:49:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X0071 已完成（上传图片的时候保存并推送）</li>
              <li>2. 更换部分icon</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.3</b>
            <br>
            <b>2021/02/05 17:00</b>
            <br>
            <b>接口版本号：v1.8.7</b>
            <b v-if="apiFlag">接口更新时间：2021/02/05 10:56:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加回调模块</li>
              <li v-if="!isSimple">2. 运维操作中增加批量重新生成图片标签和批量重新生成人脸功能</li>
              <li>3. X0081 已完成（图片邀约中的查看图片，增加选用功能）</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.2</b>
            <br>
            <b>2021/02/04 15:00</b>
            <br>
            <b>接口版本号：v1.8.5</b>
            <b v-if="apiFlag">接口更新时间：2021/02/04 11:49:33</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X0070 已完成</li>
              <li>2. 修复选用图片清空问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v1.0.1</b>
            <br>
            <b>2021/02/03 10:00</b>
            <br>

            <b>接口版本号：v1.8.3</b>
            <b v-if="apiFlag">接口更新时间：2021/02/02 17:53:54</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片中心的传参</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.9</b>
            <br>
            <b>2021/02/02 17:48</b>
            <br>
            <b>接口版本号：v1.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/01/29 11:27:21</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X0075 已完成</li>
              <li>2. X0078 已完成</li>
              <li>3. 完善选用图片功能</li>
              <li>4. 增加回调管理静态页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.8</b>
            <br>
            <b>2021/01/29 18:10</b>
            <br>
            <b>接口版本号：v1.8.0</b>
            <b v-if="apiFlag">接口更新时间：2021/01/29 11:27:21</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加客户端下载</li>
              <li>2. 增加静态智能标签</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.7</b>
            <br>
            <b>2021/01/27 16:46</b>
            <br>
            <b>接口版本号：v1.7.8</b>
            <b v-if="apiFlag">接口更新时间：2021/01/20 18:05:18</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复重复上传不可行问题，并且如果不勾选使用文件名为图片说明，则用资源集名+图集说明作为图片说明</li>
              <li>2. 上传图片中图片增加悬浮查看图片说明</li>
              <li>3. 修复站点推荐超过9个的问题</li>
              <li>4. 站点设置增加站点状态</li>
              <li>5. 修复权限问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.6</b>
            <br>
            <b>2021/01/22 17:20</b>
            <br>
            <b>接口版本号：v1.7.8</b>
            <b v-if="apiFlag">接口更新时间：2021/01/20 18:05:18</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 工作流中的站点发布的图片展示列表中推荐增加拖动排序功能，并且修复问题</li>
              <li>2. 活动投稿页面中点击投稿人，昵称改为真实姓名</li>
              <li>3. 修复未整理图片中的问题</li>
              <li>4. 完善对外展示网站的推荐</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.5</b>
            <br>
            <b>2021/01/21 18:08</b>
            <br>
            <b>接口版本号：v1.7.8</b>
            <b v-if="apiFlag">接口更新时间：2021/01/20 18:05:18</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 对外展示网站完成推荐模块</li>
              <li v-if="!isSimple">2. 资源人物管理中可以查看关联图片</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.4</b>
            <br>
            <b>2021/01/20 18:10</b>
            <br>
            <b>接口版本号：v1.7.8</b>
            <b v-if="apiFlag">接口更新时间：2021/01/20 18:05:18</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 工作流的图片展示增加推荐模块</li>
              <li>2. 对外展示网站增加推荐静态模块</li>
              <li>3. X0048 已完成</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.3</b>
            <br>
            <b>2021/01/13 16:35</b>
            <br>
            <b>接口版本号：v1.7.4</b>
            <b v-if="apiFlag">接口更新时间：2021/01/08 11:38:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 系统设置中的编辑器增加一键清除，防止重复代码导致字数过多无法提交</li>
              <li>2. 根据内部意见和客户意见，完善对外展示页面</li>
              <!-- <li>4. 增加web端和桌面软件端的联动</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.2</b>
            <br>
            <b>2021/01/12 18:05</b>
            <br>
            <b>接口版本号：v1.7.4</b>
            <b v-if="apiFlag">接口更新时间：2021/01/08 11:38:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复对外展示页面的内容并且减少加载速度</li>
              <li>2. 处理windows分屏之后，内容无法展示全的问题</li>
              <li>3. 修复站点设置中，在基本信息中无法保存友情链接的问题</li>
              <!-- <li>4. 增加web端和桌面软件端的联动</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.1</b>
            <br>
            <b>2021/01/11 18:01</b>
            <br>
            <b>接口版本号：v1.7.4</b>
            <b v-if="apiFlag">接口更新时间：2021/01/08 11:38:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复创建活动和修改活动的问题</li>
              <li>2. 对外展示页面增加友情链接</li>
              <li>3. 站点设置添加友情链接设置</li>
              <li>4. 增加web端和桌面软件端的联动</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.9.0</b>
            <br>
            <b>2021/01/08 18:10</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复轮播图设置所发现的问题</li>
              <li>2. 完善对外展示页面</li>
              <li>3. 增加图片加载和失败效果</li>
              <li>4. 修复个人图集中数据渲染失败或缓慢问题</li>
              <li>5. 修复增加了对外展示页面所产生的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.9</b>
            <br>
            <b>2021/01/07 17:55</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0142 已修复</li>
              <li>2. 0143 已修复</li>
              <li>3. 0144 已修复</li>
              <li>4. 0145 已修复</li>
              <li>5. 0146 已修复</li>
              <li>6. 0149 已修复</li>
              <li>7. 完善对外展示页面</li>
              <li>8. 活动创建的结束和开始时间改为既可以选择日期也可以选择时间</li>
              <!-- <li>5. 修复图片选用中多选操作之后站点发布不显示问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.8</b>
            <br>
            <b>2021/01/06 18:02</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 站点设置中增加友情链接操作</li>
              <li>2. 活动增加最新的首页模块，并可以展示推送的图片和设置的轮播图，频道和栏目</li>
              <li>3. 修复选用图片的展示问题</li>
              <li>4. 完善我的资源集中批量操作</li>
              <!-- <li>5. 修复图片选用中多选操作之后站点发布不显示问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.7</b>
            <br>
            <b>2021/01/05 16:23</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片中心加载问题</li>
              <li>2. 修复管理员缺少权限</li>
              <li>3. 修复未整理图片中，查看图片图片信息不全</li>
              <!-- <li>4. 完善轮播图设置中裁剪的加载问题</li> -->
              <!-- <li>5. 修复图片选用中多选操作之后站点发布不显示问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.6</b>
            <br>
            <b>2021/01/04 17:23</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复轮播图设置中空数据的问题</li>
              <li>2. 修复手机端上传图片的权限问题</li>
              <li>3. 修复图片选用的问题</li>
              <li>4. 完善轮播图设置中裁剪的加载问题</li>
              <!-- <li>5. 修复图片选用中多选操作之后站点发布不显示问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.5</b>
            <br>
            <b>2020/12/31 17:23</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片中心滚动加载问题</li>
              <li>2. 修复 0138</li>
              <li>3. 修复 0140</li>
              <li>4. 修复 0141</li>
              <li>5. 更换图片展示中栏目的ICON，并且跳转了搜索的样式</li>
              <!-- <li>2. 完善站点的推送</li>
              <li>3. 修复活动页面中四个主题的兼容性</li>
              <li>4. 完善图片选用的样式</li>
              <li>5. 修复图片选用中多选操作之后站点发布不显示问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.4</b>
            <br>
            <b>2020/12/30 17:38</b>
            <br>
            <b>接口版本号：v1.7.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/30 14:07:19</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片加载增加效果</li>
              <li>2. 完善站点的推送</li>
              <li>3. 修复活动页面中四个主题的兼容性</li>
              <li>4. 完善图片选用的样式</li>
              <li>5. 修复图片选用中多选操作之后站点发布不显示问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.3</b>
            <br>
            <b>2020/12/29 17:28</b>
            <br>
            <b>接口版本号：v1.7.0</b>
            <b v-if="apiFlag">接口更新时间：2020/12/28 23:14:05</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加个人图集中批量操作</li>
              <li>2. 删除角色增加提示语</li>
              <li>3. 修复选择创建私有或者公开图集不生效问题</li>
              <li>4. 修复轮播图设置的问题</li>
              <li>5. 修复选用图片的问题</li>
              <li>6. 修复推送到站点发布的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.2</b>
            <br>
            <b>2020/12/28 17:48</b>
            <br>
            <b>接口版本号：v1.6.9</b>
            <b v-if="apiFlag">接口更新时间：2020/12/28 12:30:50</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 推送增加站点发布</li>
              <li>2. 联调工作流中图片展示设置页面</li>
              <li>3. 完善新增的权限</li>
              <li>4. 个人图集中增加静态多选样式</li>
              <!-- <li>4. 增加管理员专用权限，目前没有权限的站点管理和工作流的图片展示都放在里面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.1</b>
            <br>
            <b>2020/12/25 18:10</b>
            <br>
            <b>接口版本号：v1.6.7</b>
            <b v-if="apiFlag">接口更新时间：2020/12/24 00:29:22</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善轮播图设置的体验效果</li>
              <li>2. 增加推送到展示网站的静态页面</li>
              <li>3. 修复选图图片中多选操作的问题</li>
              <!-- <li>4. 增加管理员专用权限，目前没有权限的站点管理和工作流的图片展示都放在里面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.8.0</b>
            <br>
            <b>2020/12/24 18:02</b>
            <br>
            <b>接口版本号：v1.6.7</b>
            <b v-if="apiFlag">接口更新时间：2020/12/24 00:29:22</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复个人图集中筛选了可见性，更新图集信息之后没有更新列表</li>
              <li>2. 修复图片中心中搜索某个字段之后点击图片没有按照搜索字段搜索</li>
              <li>3. 完成轮播图设置接口调用</li>
              <li>4. 站点管理中增加拖动功能</li>
              <li>5. 修复选用图片中下载或者推送之后不删除所选项</li>
              <li>6. 图片展示列表的栏目按照站点管理中的数据所展示</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.9</b>
            <br>
            <b>2020/12/23 18:06</b>
            <br>
            <b>接口版本号：v1.6.6</b>
            <b v-if="apiFlag">接口更新时间：2020/12/23 16:12:26</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复选用图片重复问题</li>
              <li>2. 完善图片展示设置和轮播图设置静态页面</li>
              <li>3. 增加展示站点接口</li>
              <li>4. 完成站点管理接口调用</li>
              <li>5. 选用图片增加多选操作</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.8</b>
            <br>
            <b>2020/12/22 18:21</b>
            <br>
            <b>接口版本号：v1.6.3</b>
            <b v-if="apiFlag">接口更新时间：2020/12/22 16:07:11</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复活动审核有权限无法获取问题</li>
              <li>2. 修复权限修改或者更改不更改问题</li>
              <li>3. 修改查看权限的样式</li>
              <li>4. 权限增加创建私有图集和创建公开图集</li>
              <li>5. 轮播图设置页面增加图片裁剪功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.7</b>
            <br>
            <b>2020/12/21 17:36</b>
            <br>
            <b>接口版本号：v1.6.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/10 15:16:17</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 后台管理新增站点管理静态页面</li>
              <li>2. 后台管理的工作流中新增图片展示静态页面</li>
              <li>3. 后台管理的工作流中新增图片展示设置和轮播图设置静态页面</li>
              <li>4. 完善对外展示的首页，栏目，频道和详情的静态页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.6</b>
            <br>
            <b>2020/12/18 17:20</b>
            <br>
            <b>接口版本号：v1.6.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/10 15:16:17</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复稿件审核中加载出错的图片不显示问题</li>
              <li>2. 前台增加对外展示的首页，栏目，频道和详情的静态页面</li>
              <li>3. 修复权限问题</li>
              <li>4. 修复所有错误图片或生成缩略图失败的图片的展示问题</li>
              <li>5. 选用图片增加浏览</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.4</b>
            <br>
            <b>2020/12/16 17:33</b>
            <br>
            <b>接口版本号：v1.6.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/10 15:16:17</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0127 已修复</li>
              <li>2. 减少重绘和重排</li>
              <li>3. 减少 ES6 转为 ES5 的冗余代码</li>
              <li>4. 修复推送页面的样式</li>
              <li>5. 修复我的资源集修改第二页之后的图集出错问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.3</b>
            <br>
            <b>2020/12/15 17:40</b>
            <br>
            <b>接口版本号：v1.6.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/10 15:16:17</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复调整到个人图集时不刷新</li>
              <li>2. 更改图片右击选项，现提示‘图片版权所有’</li>
              <li>3. 图片不给拖拽</li>
              <li>4. 增加首页的头部，并且动态生成</li>
              <li>5. 修复活动详情页移动端的已投稿件不按照时间排序</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.2</b>
            <br>
            <b>2020/12/14 17:10</b>
            <br>
            <b>接口版本号：v1.6.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/10 15:16:17</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 安全配置增加导入自带过滤词</li>
              <li>2. 修复个人图集中修改不刷新</li>
              <li>3. 修复手机上传到未整理图片中丢图</li>
              <li>4. 修复未整理图片中图片浏览，图片信息不显示</li>
              <!-- <li>5. 移动端所有图片浏览增加图片说明</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.1</b>
            <br>
            <b>2020/12/11 17:10</b>
            <br>
            <b>接口版本号：v1.6.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/10 15:16:17</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片生成时，展示原图变形问题</li>
              <li>2. 图片中心中增加自动生成封面</li>
              <li>3. 增加个人中心前台展示静态页面</li>
              <li>4. 增加公祭日置灰</li>
              <!-- <li>5. 移动端所有图片浏览增加图片说明</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.7.0</b>
            <br>
            <b>2020/12/9 17:20</b>
            <br>
            <b>接口版本号：v1.6.1</b>
            <b v-if="apiFlag">接口更新时间：2020/12/8 14:58:39</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图集动态</li>
              <li>2. 完善底部提交样式</li>
              <li>3. 活动详情页增加倒计时功能</li>
              <li>4. 移动端活动详情页中已投稿件可以连续滑动</li>
              <li>5. 移动端所有图片浏览增加图片说明</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.9</b>
            <br>
            <b>2020/12/8 17:46</b>
            <br>
            <b>接口版本号：v1.6.1</b>
            <b v-if="apiFlag">接口更新时间：2020/12/8 02:37:54</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加稿件拒绝理由</li>
              <li>2. 完善图片中心的图集中的图集动态</li>
              <li v-if="!isSimple">3. 完善智能节点管理的动画效果</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.8</b>
            <br>
            <b>2020/12/7 18:11</b>
            <br>
            <b>接口版本号：v1.5.8</b>
            <b v-if="apiFlag">接口更新时间：2020/12/6 08:58:09</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 文本与协议管理中增加---网站标题，网站关键词，网站摘要，网站徽标和底部版权信息</li>
              <li>2. 增加安全配置页面</li>
              <li>3. 活动页面按照文本与协议中配置的展示</li>
              <li>4. 图片中心的图集中增加图集动态和图库名</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.7</b>
            <br>
            <b>2020/12/4 15:50</b>
            <br>
            <b>接口版本号：v1.5.7</b>
            <b v-if="apiFlag">接口更新时间：2020/12/4 01:21:12</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 修复图片放大人脸位置不准确</li>
              <li>2. 修复-修改完稿件之后，修改的图片无法显示投稿时间</li>
              <li>3. 完善文本与协议管理页面</li>
              <li>4. 修复提交按钮双击问题</li>
              <li>5. 我的下载和分享只能查看自己的</li>
              <li>6. 完善第三方接入页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.6</b>
            <br>
            <b>2020/12/3 18:30</b>
            <br>
            <b>接口版本号：v1.5.6</b>
            <b v-if="apiFlag">接口更新时间：2020/12/2 17:56:22</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 稿件审核中，投稿人旁增加认证ICON，并且点击可以查看其基本信息</li>
              <li>2. 修复活动的已投稿件中图片放大不全屏问题，和拍摄时间显示不出的问题</li>
              <li>3. 修改活动首页的展示图为移动端的图片</li>
              <li>4. 完善活动中分享的页面包括pc端和移动端</li>
              <li>5. 联调共享盘管理页面</li>
              <li>6. 联调第三方接入页面</li>
              <li>7. 文本与协议管理增加底部版权信息和敏感词清单</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.5</b>
            <br>
            <b>2020/12/2 17:58</b>
            <br>
            <b>接口版本号：v1.5.2</b>
            <b v-if="apiFlag">接口更新时间：2020/12/1 18:13:03</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加图片封面自动生成</li>
              <li>2. 修复补充图集图片，图库显示错误问题</li>
              <li>3. 修复活动浏览图片变形问题</li>
              <li>4. 增加移动端活动首页</li>
              <li>5. 认证用户增加查看用户基本信息</li>
              <li>6. 活动页面的已投稿件可以查看投稿人的认证icon（pc端+移动端）</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.4</b>
            <br>
            <b>2020/12/1 17:46</b>
            <br>
            <b>接口版本号：v1.5.1</b>
            <b v-if="apiFlag">接口更新时间：2020/11/30 18:03:23</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复用户认证分页展示问题</li>
              <li>2. 修复更改路由名字之后出现的问题</li>
              <li>3. 调试平台运维中运维管理的接口</li>
              <li>4. 增加数智中心和平台运维的权限管理</li>
              <li>5. 增加活动的认证用户，不通过的理由展示</li>
              <li>6. 修复活动的已投稿件，连续查看图片的问题</li>
              <li>7. 0132 已修复</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.3</b>
            <br>
            <b>2020/11/27 18:08</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善活动首页的内容</li>
              <li>2. 新增移动端分享页面</li>
              <li>3. 完善pc端分享页面的问题</li>
              <li>4. 基础设置增加投稿自动过审规则</li>
              <!-- <li>4. 增加共享盘管理和第三方接入静态页面，并且和系统日志和运维操作，一起放在平台运维里面</li>
              <li>5. 运维操作增加重新启动共享盘服务和清除所有系统日志</li>
              <li>6. 修复图片中心的图集，展示数量过少的问题</li> -->
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.2</b>
            <br>
            <b>2020/11/26 17:38</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善活动首页的内容（目前还缺个右上角的中江网提供的logo）</li>
              <li>2. 新增活动文章页面</li>
              <li>3. 增加数据分析静态页面，并且和智能节点管理，一起放在数智中心里面</li>
              <li>4. 增加共享盘管理和第三方接入静态页面，并且和系统日志和运维操作，一起放在平台运维里面</li>
              <li>5. 运维操作增加重新启动共享盘服务和清除所有系统日志</li>
              <li>6. 修复图片中心的图集，展示数量过少的问题</li>
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.1</b>
            <br>
            <b>2020/11/25 17:46</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复资源集名字或人物名字过长，溢出问题</li>
              <li>2. 活动首页从分页变成滚动加载</li>
              <li>3. 活动的已投稿件可以连续查看稿件</li>
              <!-- <li>4. 活动的移动端页面增加下拉刷新</li> -->
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.6.0</b>
            <br>
            <b>2020/11/24 17:55</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 更改前后的路由名称</li>
              <li>2. 活动页面的已投稿件的页:默认瀑布流，分页默认80个，分页悬浮底部</li>
              <li>3. 更改活动首页内容(变成全部/进行中/已结束)</li>
              <!-- <li>4. 活动的移动端页面增加下拉刷新</li> -->
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.9</b>
            <br>
            <b>2020/11/23 17:22</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. 更改前后的路由名称</li> -->
              <li>1. 完善修改稿件的功能和样式</li>
              <!-- <li>3. 完善（移动端和PC端）个人稿件修改的内容</li>
              <li>4. 活动的移动端页面增加下拉刷新</li> -->
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.8</b>
            <br>
            <b>2020/11/20 17:22</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 资源人物管理中可以放大查看人物的照片</li>
              <li>2. 修复审核稿件中浏览图片无法左右滚动的问题</li>
              <li>3. 完善（移动端和PC端）个人稿件修改的内容</li>
              <li>4. 活动的移动端页面增加下拉刷新</li>
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.7</b>
            <br>
            <b>2020/11/19 17:46</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 图片浏览放大后依旧可以查看人脸</li>
              <li>2. 活动页面的个人稿件可以修改（移动端）</li>
              <li>3. 平台运维---重新生成共享盘账号可以使用，增加清除所有用户权限缓存</li>
              <li>4. 更改图集展示样式</li>
              <!-- <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.6</b>
            <br>
            <b>2020/11/18 17:33</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片浏览中，点击图片鼠标样式变为放大镜</li>
              <li>2. 活动页面的个人稿件可以修改（PC端）</li>
              <li>3. 修改投稿图片筛选的备注样式</li>
              <li v-if="!isSimple">4. 更改标记人物中表格的人脸位置</li>
              <li>5. 更改创建活动的各个选项的位置，并且统一了图片尺寸建议</li>
              <li>6. 投稿图片筛选的图片浏览增加拍摄时间</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.5</b>
            <br>
            <b>2020/11/17 17:18</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加用户备注展示区域</li>
              <li>2. 隐藏图片浏览中的浏览量，推送量和平台数</li>
              <li>3. 如果图片没有说明，则隐藏</li>
              <li>4. 更改个人资源库中的内容</li>
              <li v-if="!isSimple">5. 人脸识别增加全选和取消全选功能</li>
              <li v-if="!isSimple">6. 检索人物列表的时候增加头像，可以查看用于区分人物</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.4</b>
            <br>
            <b>2020/11/16 17:36</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 个人资源库的人脸识别增加总数</li>
              <li>2. 白色主题更改展示方式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.3</b>
            <br>
            <b>2020/11/13 17:06</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加平台运维静态页面</li>
              <li>2. 修复基础设置中认证相关的问题</li>
              <li>3. 更改用户认证的表格样式</li>
              <li>4. 修复错误提示</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.2</b>
            <br>
            <b>2020/11/12 17:23</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 修复图片中心人物筛选的问题</li>
              <li>2. 修复图片上传，错误图片不显示的问题</li>
              <li>3. 完善所有滚动加载样式</li>
              <!-- <li>4. 更改活动页面注册协议和认证协议的展现方式（PC+移动）</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.1</b>
            <br>
            <b>2020/11/11 17:26</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图片浏览放大之后的问题</li>
              <li>2. 修复活动列表页面如遇到创建人等不存在，默认暂无</li>
              <li v-if="!isSimple">3. 修复人脸识别中的样式问题</li>
              <li>4. 更改活动页面注册协议和认证协议的展现方式（PC+移动）</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.5.0</b>
            <br>
            <b>2020/11/10 18:30</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 投稿图片筛选增加备注展示</li>
              <li>2. 所有图片浏览增加放大效果</li>
              <li v-if="!isSimple">3. 图片中心增加人物筛选静态</li>
              <li>4. 更改个人资源库中筛选项的位置</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.9</b>
            <br>
            <b>2020/11/09 17:22</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片浏览显示拍摄时间，如果字段无值，显示'无'</li>
              <li>2. 个人图集中修改图集时，如果libId为空或0，提示用户选中图集</li>
              <li>3. 工作桌面的图片分享次数改为图集数，并且放在第一个</li>
              <li>4. 根据接口修改创建活动的字段</li>
              <li>5. 个人资源库增加状态筛选</li>
              <li v-if="!isSimple">6. 人脸识别功能增加批量合并操作</li>
              <li>7. 修复创建图集之后，loading不消失问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.8</b>
            <br>
            <b>2020/11/06 17:16</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 增加个人资源库的人脸识别模块</li>
              <li>2. 修复资源集名重复问题</li>
              <li>3. 修复筛选投稿图片时，忽略稿件不显示数量问题</li>
              <li>4. 更改图片操作按钮位置</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.7</b>
            <br>
            <b>2020/11/05 17:10</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 图片中心中人脸识别功能中可以标识人物（合并已有人物和创建新人物）</li>
              <li v-if="!isSimple">2. 修复标识人物功能</li>
              <li>3. 修复用户管理界面（外部用户修改和添加不显示角色信息）</li>
              <li>4. 修复审核活动征稿页面，操作完停留在当前页面</li>
              <li>5. 用户管理界面隐藏删除操作</li>
              <li>6. 修复图集没有图片，封面为空</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.6</b>
            <br>
            <b>2020/11/04 17:55</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 个人图集中人脸识别功能中可以标识人物（合并已有人物和创建新人物）</li>
              <li>2. 修复活动页面移动端返回问题</li>
              <li>3. 修复活动页面白色主题四个栏目错位问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.5</b>
            <br>
            <b>2020/11/03 17:10</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片中心的图集增加创建人</li>
              <li v-if="!isSimple">2. 完善人脸识别功能</li>
              <li>3. 完善活动页面的展示效果和呈现方式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.4</b>
            <br>
            <b>2020/11/02 17:32</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复图集中无法滚动加载的问题</li>
              <li v-if="!isSimple">2. 完善人脸识别功能</li>
              <!-- <li>3. 完善人脸识别功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.3</b>
            <br>
            <b>2020/10/29 19:00</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修改错误页面内容</li>
              <li>2. 完成 X0046</li>
              <li>3. 修复 0131</li>
              <li>4. 修复 0133</li>
              <li v-if="!isSimple">5. 个人图集中查看图集增加人脸识别(目前只能展示识别到的人脸位置暂未可以设置人脸)</li>
              <li v-if="!isSimple">6. 图片中心中查看图集和图片列表增加人脸识别(目前只能展示识别到的人脸位置暂未可以设置人脸)</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.2</b>
            <br>
            <b>2020/10/28 16:48</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 更改资源集名称长度限制为45字符以内</li>
              <li>2. 修改稿件审核页面中按钮的逻辑</li>
              <li>3. 修复 X0041(强制下线问题)</li>
              <li>4. 图片邀约中增加压缩包下载和pdf下载，目前设置为灰色不可点击</li>
              <li>5. 创建活动增加稿件个数限制，目前隐藏</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.1</b>
            <br>
            <b>2020/10/27 15:55</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复审核投稿活动，点击入库没有反应问题</li>
              <li>2. 修复在图集中浏览图片的问题</li>
              <li>3. 修复活动界面中已投稿件分页问题和浏览稿件图片的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.4.0</b>
            <br>
            <b>2020/10/26 18:06</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 系统设置的基础设置中增加自动入库设置</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.9</b>
            <br>
            <b>2020/10/23 18:01</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善短信验证和手机号找回样式（PC端+移动端）</li>
              <li>2. 活动首页轮播图换为所有活动</li>
              <li>3. 活动首页进行中的活动显示所剩时间</li>
              <li>4. 从活动首页进入结束的活动，首先查看已投稿件</li>
              <li>5. 修复从活动首页进入活动，再返回404的错误</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.8</b>
            <br>
            <b>2020/10/22 16:16</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 后台管理系统登录页面增加忘记密码通过短信验证码找回功能</li>
              <li>2. 活动页面增加短信注册和通过短信验证码找回功能（pc端+移动端）</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.7</b>
            <br>
            <b>2020/10/21 17:33</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 系统设置的基础设置展示消息通知</li>
              <li>2. 增加滑动验证模块（PC端+移动端）</li>
              <li>3. 完善静态验证码模块</li>
              <!-- <li>4. 0128 已修复</li> -->
              <!-- <li>5. 0130 已修复</li> -->
              <!-- <li>6. 0131 已修复</li> -->
              <!-- <li>7. 0132 已修复</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.6</b>
            <br>
            <b>2020/10/20 17:16</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 隐藏活动页面的白色主题的已投稿件的展示方式（后续有接口再添加）</li>
              <li>2. 增加静态验证码模块（PC端+移动端）</li>
              <!-- <li>4. 0128 已修复</li> -->
              <!-- <li>5. 0130 已修复</li> -->
              <!-- <li>6. 0131 已修复</li> -->
              <!-- <li>7. 0132 已修复</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.5</b>
            <br>
            <b>2020/10/19 17:22</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善活动页面的白色主题的已投稿件的展示方式</li>
              <li>2. 完善后台移动端图片上传</li>
              <li>3. 修复前台移动端图片上传</li>
              <li>4. 修复一系列自己发现的问题</li>
              <!-- <li>4. 0128 已修复</li> -->
              <!-- <li>5. 0130 已修复</li> -->
              <!-- <li>6. 0131 已修复</li> -->
              <!-- <li>7. 0132 已修复</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.4</b>
            <br>
            <b>2020/10/16 16:56</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0102 已修复</li>
              <li>2. 活动页面的白色主题的稿件页面，变为两种展示方式（图片和稿件）</li>
              <li>3. 修复一系列自己发现的问题</li>
              <!-- <li>4. 0128 已修复</li> -->
              <!-- <li>5. 0130 已修复</li> -->
              <!-- <li>6. 0131 已修复</li> -->
              <!-- <li>7. 0132 已修复</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.3</b>
            <br>
            <b>2020/10/15 17:12</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0129 已修复</li>
              <li>2. 完善手机上传图片</li>
              <li>3. 修复一系列自己发现的问题</li>
              <!-- <li>4. 0128 已修复</li> -->
              <!-- <li>5. 0130 已修复</li> -->
              <!-- <li>6. 0131 已修复</li> -->
              <!-- <li>7. 0132 已修复</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.2</b>
            <br>
            <b>2020/10/14 17:36</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0105 已修复</li>
              <li>2. 0112 已修复</li>
              <li>3. 0119 已修复</li>
              <li>4. 0128 已修复</li>
              <li>5. 0130 已修复</li>
              <li>6. 0131 已修复</li>
              <li>7. 0132 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.1</b>
            <br>
            <b>2020/10/13 17:05</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0109 已修复</li>
              <li>2. 0124 已修复</li>
              <li>3. 0126 已修复</li>
              <li>4. 0113 已修复</li>
              <li>5. 0114 已修复</li>
              <li>6. 活动图片筛选结束之后，pdf下载会打开新页面展示</li>
              <li>7. 解决送审时如果遇到同名的人无法判别</li>
              <li>8. 修复一系列口述问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.3.0</b>
            <br>
            <b>2020/10/12 17:20</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0110 已修复</li>
              <li>2. X0040 已完成</li>
              <li>3. X0034 已完成</li>
              <li>4. X0037 已完成</li>
              <li>5. 修复一系列自己发现的bug</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.9</b>
            <br>
            <b>2020/10/10 17:40</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0111 已修复</li>
              <li>2. 0118 已修复</li>
              <li>3. 0119 已修复</li>
              <li>4. 0121 已修复</li>
              <li>5. 0122 已修复</li>
              <li>6. 0123 已修复</li>
              <li>7. 审核活动征稿页面中，选中的图片增加到setUserSetting中，并且可以查看选中的图片（更换设备，选中图片不消失）</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.8:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复头部logo去除圆角</li>
              <li>2. 修复图片归档完再次选择图片卡顿问题</li>
              <li>3. 0116 已修复</li>
              <li>4. 活动页面中白色主题更换图片浏览方式</li>
              <li>5. 完善活动页面图片上传</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.7:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善投稿图片筛选</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.6:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复投稿图片筛选中图片浏览中按钮不起作用</li>
              <li>2. 修复活动页面中我的稿件展示问题并且增加审核状态（PC+移动）</li>
              <li>3. 活动页面的pc端增加可以查看是否为认证用户</li>
              <li>4. 活动如果是需要认证用户投稿，普通用户点击提交自动跳转到填写认证界面（PC+移动）</li>
              <li>5. 修复'修改个人信息'无法点击和无法退出的问题</li>
              <li>6. 用户管理中检索用户姓名支持模糊查询</li>
              <li>7. 活动征稿中图片增加投稿时间</li>
              <li>8. 禁止移动端活动页面在手机上可以放大和缩小</li>
              <!-- <li>9. 禁止移动端活动页面在手机上可以放大和缩小</li> -->
              <li>9. 移动端登录增加返回按钮</li>
              <li>10. 修复移动端活动返回没有数据</li>
              <li>11. 增加移动端活动页面的标题带入活动名字</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.5:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 选用图片调取UserSetting系列接口</li>
              <li>2. 修复管理员图库问题</li>
              <li>3. 修改审核图片筛选的眼睛icon为放大镜</li>
              <li>4. 0106 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.4:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 用户管理增加检索姓名，目前只支持精准检索</li>
              <li>2. 修复活动稿件页面</li>
              <li>3. 增加活动首页</li>
              <li>4. 修复退出登录，选用图片不清楚问题</li>
              <li>5. 修复浏览器提示问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.3:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复用户管理分页问题</li>
              <li>2. 增加活动投稿显示的个数</li>
              <li>3. 修复活动投稿分页问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.2:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 没有角色的用户不给登录（除管理员以外）</li>
              <li>2. 0096 已修复</li>
              <li>3. 0102 已修复</li>
              <li>4. 修复活动图片筛选中，投稿用户删除之后，无法显示问题</li>
              <li>5. 修复活动注册提示语</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.2:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 系统设置中的基础设置的认证相关，增加投稿权限，具体有注册用户和认证用户</li>
              <li>2. 增加智能中心圆圈动效</li>
              <li>3. 修复活动投稿图片上传的问题</li>
              <li>4. 0101 已修复</li>
              <li>5. 0103 已修复</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.1:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复白色主题pc端导航条居中的问题</li>
              <li>2. 增加一些智能中心动画效果</li>
              <li>3. 0098 已修复</li>
              <li>4. 0100 已修复</li>
              <li>5. 0101 已修复</li>
              <li>6. 使用ie等低端浏览器会有对应的提示语</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.2.0:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复移动端活动页面的'我要投稿'，跳转效果</li>
              <li>2. 完善活动页面中的白色主题</li>
              <li>3. 增加一些智能中心动画效果</li>
              <li>4. 0099 已修复</li>
              <li>5. 0100 已修复</li>
              <li>6. 0101 已修复</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.9:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复个人图集中修改或新建资源集，图库不显示</li>
              <li>2. 修复图片上传中图库不显示</li>
              <li>3. 修复投稿图片筛选无法获取到自己操作的任务</li>
              <li>4. 0086 已修复</li>
              <li>5. 0091 已修复</li>
              <li>6. 0093 已修复</li>
              <li>7. 0097 已修复</li>
              <li>8. 0098 已修复</li>
              <!-- <li>4. 0083 已修复</li>
              <li>5. 0085 已修复</li>
              <li>6. 0088 已修复</li>
              <li>7. 0089 已修复</li>
              <li>8. 0090 已修复</li>

              <li>9. 0092 已修复</li>
              <li>10. 0094 已修复</li>
              <li>11. 0095 已修复</li>
              <li>12. 增加移动端白色主题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.8:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善白色主题页面和功能</li>
              <li>2. 创建活动增加三个选项</li>
              <!-- <li>3. 修改白色主题PC端的样式</li> -->
              <!-- <li>4. 0083 已修复</li>
              <li>5. 0085 已修复</li>
              <li>6. 0088 已修复</li>
              <li>7. 0089 已修复</li>
              <li>8. 0090 已修复</li>

              <li>9. 0092 已修复</li>
              <li>10. 0094 已修复</li>
              <li>11. 0095 已修复</li>
              <li>12. 增加移动端白色主题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.7:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 用户管理分为内部用户和外部用户</li>
              <li>2. 新建征稿活动增加三个字段（投稿角色，稿件正文，图片备注）</li>
              <li>3. 修改白色主题PC端的样式</li>
              <li>4. 0083 已修复</li>
              <li>5. 0085 已修复</li>
              <li>6. 0088 已修复</li>
              <li>7. 0089 已修复</li>
              <li>8. 0090 已修复</li>

              <li>9. 0092 已修复</li>
              <li>10. 0094 已修复</li>
              <li>11. 0095 已修复</li>
              <li>12. 增加移动端白色主题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.6:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0063 已修复</li>
              <li>2. 0068 已修复</li>
              <li>3. 0076 已修复</li>
              <li>4. 0077 已修复</li>
              <li>5. 0078 已修复</li>
              <li>6. 0079 已修复</li>
              <li>7. 0080 已修复</li>
              <li>8. 0053 已修复</li>

              <li>9. 修改活动征稿页面</li>
              <li>10. 增加一个活动主题（PC端），白色主题（white）</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.6:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0037 已修复</li>
              <li>2. 0053 已修复</li>
              <li>3. 0054 已修复</li>
              <li>4. 0055 已修复</li>
              <li>5. 0062 已修复</li>
              <li>6. 0072 已修复</li>
              <li>7. 0075 已修复</li>
              <li>8. 0077 已修复</li>
              <!-- <li>1. X0030 已完成</li> -->
              <!-- <li>3. 0071 已修复</li>
              <li>4. 0072 已修复</li>
              <li>5. 活动投稿增加上传进度条</li>
              <li>6. 图片上传增加'ctrl+v'增加图片</li> -->
              <li>9. 认证相关中增加地区字段</li>
              <li>10. 活动征稿页面增加我的投稿</li>
              <li>11. X0021 已完成</li>
              <li>12. 内部用户无法登录活动页面，外部用户无法登录后台页面</li>
              <!-- <li>4. X0024 已完成</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.5:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X0030 已完成</li>
              <li>2. 增加智能中心静态页面</li>
              <!-- <li>3. 0071 已修复</li>
              <li>4. 0072 已修复</li>
              <li>5. 活动投稿增加上传进度条</li>
              <li>6. 图片上传增加'ctrl+v'增加图片</li> -->
              <li>3. 0074 已修复</li>
              <!-- <li>4. X0024 已完成</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.4:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0066 已修复</li>
              <li>2. 0070 已修复</li>
              <li>3. 0071 已修复</li>
              <li>4. 0072 已修复</li>
              <li>5. 活动投稿增加上传进度条</li>
              <li>6. 图片上传增加'ctrl+v'增加图片</li>
              <!-- <li>5. 0067 已修复</li> -->
              <!-- <li>4. X0024 已完成</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.3:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 活动移动端增加锚点跳转</li>
              <li>2. 优化活动筛选图片页面</li>
              <li>3. 增加获取已授权图库列表接口</li>
              <li>4. 0038 已修复</li>
              <li>5. 0067 已修复</li>
              <!-- <li>4. X0024 已完成</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.2:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0060 已修复</li>
              <li>2. 0061 已修复</li>
              <li>3. 0064 已修复</li>
              <li>4. 活动页面增加注册和认证协议</li>
              <li>5. 完善移动端活动页面</li>
              <!-- <li>4. X0024 已完成</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.1:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0016 已修复</li>
              <li>2. 0059 已修复</li>
              <li>3. 0060 已修复</li>
              <li>4. X0023 已完成</li>
              <li>5. X0024 已完成</li>
              <!-- <li>4. X0024 已完成</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.1.0:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0058 已修复</li>
              <li>2. 图片中心可以修改个人图集的图集说明</li>
              <li>3. 修复图片邀约的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.61:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0031 已修复</li>
              <li>2. X0019 已完成（个人图集，图片中心和活动征稿）</li>
              <li>3. 更换操作按钮图标</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.60:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善手机端筛选界面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.59:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0054 已修复</li>
              <li>2. 0057 已修复</li>
              <li>3. 如果筛选图片的操作人不是自己 无法操作</li>
              <li>4. 手机端筛选界面增加保存并结束按钮</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.58:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0050 已修复</li>
              <li>2. 0051 已修复</li>
              <li>3. X0008 已完成</li>
              <li>4. 增加投稿图片筛选界面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.57:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X0014 已完成</li>
              <li>2. X0022 已完成</li>
              <li>3. 根据测试的建议修改云知</li>
              <li>4. 增加投稿图片筛选界面，目前为测试版本</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.56:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0041 已修复</li>
              <li>2. 0043 已修复</li>
              <li>3. 完善投稿图片筛选界面</li>
              <li>4. 增加手机端投稿图片的框架</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.55:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善投稿图片筛选界面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.54:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 联调投稿图片筛选的所有接口</li>
              <li>2. 修复个人图集中新增资源集的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.53:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加投稿图片筛选所有静态页面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.52:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0040 已修复</li>
              <li>2. 0047 已修复</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.51:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加移动端个人中心页面</li>
              <li>2. 修复图片中心推送样式的问题</li>

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.50:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加部分移动端个人中心页面</li>
              <!-- <li>5. 修复图片浏览中放大缩小不居中的问题</li> -->

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.49:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加活动主题修改功能</li>
              <li>2. 增加活动投稿的登录页面</li>
              <!-- <li>5. 修复图片浏览中放大缩小不居中的问题</li> -->

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.48:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0034 已修复</li>
              <li>2. 修改用户认证</li>
              <li>3. 隐藏不需要的模块</li>
              <li>4. 联调活动征稿中个人中心的内容</li>
              <!-- <li>5. 修复图片浏览中放大缩小不居中的问题</li> -->

            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.47:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 修改基础设置，增加用户认证相关的字段配置</li>
              <li>2. 图片上传增加二次拖拽</li>
              <li>3. 0036 已修复</li>
              <li>4. 手机上传增加归档到图集</li>
              <li>5. 修复图片浏览中放大缩小不居中的问题</li>
              <!-- <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.46:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 增加工作流的选项卡，横排显示和竖排显示的通用模板</li>
              <li>2. X0015 已完成</li>
              <li>3. X0016 已完成</li>
              <li>4. 修复未整理图片滚动问题</li>
              <!-- <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.45:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 联调活动征稿的个人中心的我的稿件的界面</li>
              <li>2. 联调文本与协议管理的界面</li>
              <li>3. 更改活动征稿登录页面的接口为userLogin</li>
              <!-- <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.44:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 修改新建活动投稿的界面</li>
              <li>2. 修改基础设置的界面</li>
              <li>3. 增加图片拖拽上传</li>
              <!-- <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.43:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 增加用户认证静态界面</li>
              <li>2. 增加文本与协议管理静态界面</li>
              <li>3. 查看图集增加返回操作</li>
              <!-- <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.42:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 修复图集过长，归档到图集的表格高度过高</li>
              <li>2. X0011 已修复</li>
              <li>3. 0029 已修复</li>
              <!-- <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.41:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 完善 X0005</li>
              <li>2. 0022 已修复</li>
              <li>3. 0024 已修复</li>
              <li>4. X0013 已修改</li>
              <li>3. 0026 已修复</li>
              <li>3. 0028 已修复</li>
              <li>3. 0029 已修复</li>
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.40:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. X0005 已完成</li>
              <li>2. 0021 已修复</li>
              <li>3. 0023 已修复</li>
              <li>4. 图片上传错误信息会传递至sessionstorage</li>
              <!-- <li>3. 活动页面增加个人中心的静态页面，后缀改为'personalcenter',就可以查看</li> -->
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.39:</b>
          </td>
          <td colspan="3">
            <ol>
              <!-- <li>1. X0003 已完善</li> -->
              <li>1. 0004 已修复（增加旋转功能）</li>
              <li>2. 修复征稿活动页重复数据</li>
              <li>3. 活动页面增加个人中心的静态页面，后缀改为'personalcenter',就可以查看</li>
              <!-- <li>4. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.38:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. X0003 已完善</li>
              <li>2. 0022 已修复</li>
              <!-- <li>3. 0021 已修复</li> -->
              <!-- <li>3. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.37:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0019 已完善</li>
              <li>2. 0020 已修复</li>
              <li>3. 0021 已修复</li>
              <!-- <li>3. 优化图片上传和未整理图片界面</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.36:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 0018 已修复</li>
              <li>2. 0019 已修复</li>
              <li>3. 优化图片上传和未整理图片界面</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.35:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善未整理图片和图片上传样式</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.34:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 2020-8-4-0005 已修复</li>
              <li>2. 2020-8-4-0009 已修复</li>
              <li>3. 2020-8-4-0013 已修复</li>
              <li>4. 2020-8-4-0015 已修复</li>
              <li>5. 2020-8-4-X0003 已完成</li>
              <li>6. 2020-8-4-X0004 已完成</li>
              <li>7. 2020-8-4-X0006 已完成</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.33:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 2020-8-3-0008 已修复</li>
              <li>2. 2020-8-3-0009 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.32:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 2020-8-3-X0002 已完成</li>
              <li>2. 2020-8-3-0002 已修复</li>
              <li>3. 2020-8-3-0003 已修复</li>
              <li>4. 2020-8-3-0007 已修复</li>
              <li>5. 2020-8-3-00010 已修复</li>
              <li>6. 2020-8-3-00011 已修复</li>
              <li>7. 2020-8-3-00012 已修复</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.31:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 隐藏所有与分享有关内容</li>
              <li>2. 资源库管理中，删除按钮隐藏</li>
              <li>3. 修复活动征稿</li>
              <li>4. 增加未整理图片，批量删除；并且更改选中图片的位置</li>
              <li>5. 可以多次选择上传图片</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.30:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善手机上传</li>
              <!-- <li>2. 完善活动投稿页面</li> -->
              <!-- <li>3. 图片中心的图片增加预览功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.29:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善用户管理功能</li>
              <li>2. 完善活动投稿页面</li>
              <!-- <li>3. 图片中心的图片增加预览功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.28:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善上传功能</li>
              <li>2. 完善活动投稿页面</li>
              <li>3. 图片中心的图片增加预览功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.27:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 隐藏暂未开发或未完善的功能</li>
              <!-- <li>2. 修复大屏图片显示不全</li> -->
              <!-- <li>3. 修复上传功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.26:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加活动征稿移动端页面</li>
              <!-- <li>2. 修复大屏图片显示不全</li> -->
              <!-- <li>3. 修复上传功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.25:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善手机上传功能</li>
              <!-- <li>2. 修复大屏图片显示不全</li> -->
              <!-- <li>3. 修复上传功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.24:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 效验链接</li>
              <li>2. 修复大屏图片显示不全</li>
              <!-- <li>3. 修复上传功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.23:</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 隐藏修改密码，人脸识别，管理者和用稿者工作桌面</li>
              <!-- <li>2. 修复无法滚动加载图片</li>
              <li>3. 修复上传功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.22:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复基础设置功能</li>
              <li>2. 修复无法滚动加载图片</li>
              <li>3. 修复上传功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.21:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片地址随域名而改变</li>
              <li>2. 手机上传地址随基础设置中的内部域名而改变</li>
              <li>3. 征稿活动地址随基础设置中的外部域名而改变</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.20:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 图片中心不再展示私有图集</li>
              <!-- <li>2. 修复未整理图片的问题</li> -->
              <!-- <li>3. 修复基础设置无法设置的问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.19:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 更换分享与推送的接口</li>
              <li>2. 修复未整理图片的问题</li>
              <!-- <li>3. 修复基础设置无法设置的问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.18:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复演示中发现的问题</li>
              <!-- <li>2. 修复进入无法访问页面返回的问题</li> -->
              <!-- <li>3. 修复基础设置无法设置的问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.17:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善云图，修复bug</li>
              <!-- <li>2. 修复进入无法访问页面返回的问题</li> -->
              <!-- <li>3. 修复基础设置无法设置的问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.16:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善权限设置</li>
              <!-- <li>2. 修复进入无法访问页面返回的问题</li> -->
              <!-- <li>3. 修复基础设置无法设置的问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.15:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复登录权限问题</li>
              <li>2. 修复进入无法访问页面返回的问题</li>
              <!-- <li>3. 修复基础设置无法设置的问题</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.14:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 征稿活动和图片邀约的查看图片更换最新的接口</li>
              <li>2. 修复我的下载卡顿问题</li>
              <li>3. 修复基础设置无法设置的问题</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.13:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加图片邀约的查看图片按钮</li>
              <!-- <li>2. 修复全媒体和融媒体推送页面</li>
              <li>3. 修复未整理图片功能</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.12:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善征稿活动页面</li>
              <li>2. 修复全媒体和融媒体推送页面</li>
              <li>3. 修复未整理图片功能</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.11:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加征稿活动页面（除了图片浏览和活动征稿的推送，其他均可以使用）</li>
              <li>2. 完善征稿活动和图片邀约的权限功能</li>
              <!-- <li>3. 增加图片中心和个人资源库的权限</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.10:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善活动征稿和图片邀约权限问题内容</li>
              <li>2. 修复手机上传图片传递token的问题</li>
              <li>3. 增加图片中心和个人资源库的权限</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.09:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 分享与推送增加查看图片功能</li>
              <!-- <li>2. 完善权限的设置</li> -->
              <!-- <li>3. 更改我的邀约的位置，并且命名为'指派给我的邀约'</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.08:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复手机上传权限问题</li>
              <!-- <li>2. 完善权限的设置</li> -->
              <!-- <li>3. 更改我的邀约的位置，并且命名为'指派给我的邀约'</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.07:</b>
          </td>
          <td colspan="3">
            <ol>
              <li v-if="!isSimple">1. 增加人脸识别静态页面</li>
              <li>2. 完善权限的设置</li>
              <li>3. 更改我的邀约的位置，并且命名为'指派给我的邀约'</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.06:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 更加权限新的接口，完善权限功能</li>
              <!-- <li>2. 完善权限的设置</li> -->
              <!-- <li>3. 更改图集中图片展示的src</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.05:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复删除浏览器无法活动用户ID的问题</li>
              <li>2. 完善权限的设置</li>
              <!-- <li>3. 更改图集中图片展示的src</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.04:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 增加个人资源库中图集可以删除和取消归档</li>
              <li>2. 征稿活动的活动链接可以点击，并且有相应的内容</li>
              <!-- <li>3. 更改图集中图片展示的src</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.03:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 完善图片上传，改变了上传样式</li>
              <li>2. 修复了活动投稿的活动链接</li>
              <li>3. 更改图集中图片展示的src</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.02:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 修复pc端上传的样式，提高图片显示的速度</li>
              <li>2. 完善角色列表</li>
              <!-- <li>3. 修复手机上传和基础设置</li> -->
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>v0.0.01:</b>
          </td>
          <td colspan="3">
            <ol>
              <li>1. 新增活动主题管理</li>
              <li>2. 新增征稿活动管理</li>
              <li>3. 修复手机上传和基础设置</li>
            </ol>
          </td>
        </tr>

        <tr>
          <td>
            <b>更早版本：</b>
          </td>
          <td colspan="3">
            早期版本纯开发阶段，变动太大不做记录。
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import { mapActions } from "vuex";
import { getToken } from '@/api/user'

export default {

  data () {
    return {
      now: '',
      timer: null,
      apiFlag: false
    }
  },
  methods: {
    getNow () {
      this.timer = setInterval(() => {
        var time = new Date();
        this.now = time.toLocaleString()
      }, 1000);
    }
  },
  created () {
    // this.now = this.now.Format("yyyy-MM-dd hh:mm:ss")
    this.getNow()
  },
  mounted () {

  },
  beforeDestroy () {
    clearTimeout(this.timer)
  }


};
</script>

<style lang="scss" scoped>
@import "./versionChange.scss";

a {
  font-size: 14px;
  color: white;
  text-decoration: none;
} //未访问：蓝色、无下划线

a:visited {
  color: purple;
} //已访问：紫色、无下划线
a:hover {
  color: red;
  // text-decoration: underline;
} //鼠标移近：红色、下划线
</style>

